import {Component} from '@angular/core';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css', '../myreports.component.css']
})
export class ChartsComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/charts/charts.component.ts